module.exports = __webpack_public_path__ + "static/united-states-of-america-flag-square-xs@2x-687409b1380cf01e125251cfca355f08.png";